import { OrganizationException } from '@/domain/organization/exception/OrganizationException'

export class InvalidPhoneNumberException extends OrganizationException {
}
